import { Placement } from "./Placement";
import Sprite from "../components/object-graphics/Sprite";
import { TILES } from "../helpers/tiles";
import { PLACEMENT_TYPE_HERO, INVENTORY } from "../helpers/consts";

export class BulletDropboxPlacement extends Placement {
  dropsBulletOnCollide(forBody) {
    return (
      forBody.type === PLACEMENT_TYPE_HERO &&
      this.level.inventory.has(INVENTORY.BULLET_PICKUP)
    );
  }

  renderComponent() {
    return <Sprite frameCoord={TILES.BULLET_DROPBOX} />;
  }
}
